"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ShapeBaseGLFilter = _interopRequireDefault(require("./ShapeBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ShapeBlurCutoffGLFilter extends _ShapeBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision highp float;

        vec3 L2Gray(vec3 L)
        {
            // L = L*100.0; // scale into traditional L range
            L = (L+vec3(16.0))/vec3(116.0); // XYZ transformation step
            // x=y=z= L^3
            // so the matrix multiply becomes R = m00*x+m01*x+.. = x * (m00+m01+..)
            // and since all rows add up to 1, it is just x that remains
            return L*L*L;
        }

        #define CHANNEL0 0x1
        #define CHANNEL1 0x2
        #define CHANNEL2 0x4

        #define SINGLE_CHANNEL 1

        uniform sampler2D t_tex;
        varying highp vec2 v_uv;
        uniform int outChannel; // which channel(s) to compute
        #if(SINGLE_CHANNEL)
            uniform float sensitivity;
            uniform float steepness;
            uniform float offset;
        #else
            uniform vec3 sensitivity;
            uniform vec3 steepness;
            uniform vec3 offset;
        #endif

        void main()
        {
            vec2 pos = v_uv;
            vec4 pSrc = texture2D(t_tex,pos); // hi-bits of center surround stored in xy, low-bits in zw

            //float sensitivity.x = mix(0.97,0.99,sensitivity.x);
            #if(1)
                float src = (pSrc.x - sensitivity * pSrc.y) - offset;
                float edge = ( src > 0.0)? 1.0 : 2.0 * smoothstep(-2.0, 2.0, steepness * src );
                edge = edge > 0.5 ? 1.0 : 0.0;
                gl_FragColor = vec4(edge,edge,edge,1.0);
                //gl_FragColor.rgb = pSrc;
            #else
                vec3 src = (vec3(pSrc.x) - sensitivity * vec3(pSrc.y)) - offset;
                // the following is supposedly the vector form of:
                // float edge = ( src > 0.0f)? 1.0f : 2.0f * smoothStep(-2.0f, 2.0f, steepness* src );
                //vec3 test = vec3(src.x>0.0 ? 0.0 : 1.0, src.y>0.0 ? 0.0 : 1.0, src.z>0.0 ? 0.0 : 1.0);  // greaterThan( src, vec3(0.0));
                //for some reason this mix overload doesn't seem to work... Grrrrrr... ok... doing it manually
                //vec3 edge = mix(vec3(2.0) * smoothstep(vec3(-2.0), vec3(2.0), steepness * src ), vec3(1.0), test);
                //vec3 val = vec3(2.0) * smoothstep(vec3(-2.0), vec3(2.0), steepness * src );
                //vec3 edge = mix(val,1.0,test);
                vec3 edge;
                //if(outChannel & CHANNEL0)
                edge[0]= ( src[0] > 0.0)? 1.0 : 2.0 * smoothstep(-2.0, 2.0, steepness[0] * src[0] );
                //if(outChannel & CHANNEL1)
                edge[1]= ( src[1] > 0.0)? 1.0 : 2.0 * smoothstep(-2.0, 2.0, steepness[1] * src[1] );
                //if(outChannel & CHANNEL2)
                edge[2]= ( src[2] > 0.0)? 1.0 : 2.0 * smoothstep(-2.0, 2.0, steepness[2] * src[2] );

                gl_FragColor.xyz = edge;
            #endif
        }
        `;
    super(fsSource);
    this._offset = 0.0173;
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.sensitivity = gl.getUniformLocation(program, 'sensitivity');
    uniformLocations.steepness = gl.getUniformLocation(program, 'steepness');
    uniformLocations.offset = gl.getUniformLocation(program, 'offset');
    return uniformLocations;
  }

  willDraw(gl) {
    super.willDraw(gl);
    gl.uniform1f(this.uniformLocations.sensitivity, 0.96);
    gl.uniform1f(this.uniformLocations.steepness, 400);
    gl.uniform1f(this.uniformLocations.offset, this._offset);
  }

  setDetail(valueInPercentage) {
    this._offset = 0.03 * valueInPercentage / 100.0;
  }

  getDetail() {
    return this._offset * 100.0 / 0.03;
  }

}

exports.default = ShapeBlurCutoffGLFilter;